module.exports = __webpack_public_path__ + "static/img/2.2d6ca33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R134A/2.jpg
// module id = AiAR
// module chunks = 1